import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize} from 'rxjs';
import {LoaderService} from '../services/loader.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);

  if (req.headers.has('X-Skip-Loading')) {
    return next(req);
  }

  loader.show();
  return next(req).pipe(finalize(() => loader.hide()));
};
